var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62506 11.3752H3.50006V17.5002C3.50006 18.4653 4.28493 19.2502 5.25006 19.2502H15.7501C16.7152 19.2502 17.5001 18.4653 17.5001 17.5002V11.3752H18.3751C18.5481 11.3751 18.7172 11.3238 18.8611 11.2277C19.0049 11.1315 19.1171 10.9949 19.1833 10.835C19.2495 10.6751 19.2668 10.4992 19.2331 10.3295C19.1993 10.1598 19.116 10.0039 18.9937 9.88155L11.1187 2.00655C11.0375 1.92522 10.9411 1.8607 10.8349 1.81668C10.7288 1.77266 10.615 1.75 10.5001 1.75C10.3851 1.75 10.2714 1.77266 10.1652 1.81668C10.0591 1.8607 9.96262 1.92522 9.88143 2.00655L2.00643 9.88155C1.8841 10.0039 1.80079 10.1598 1.76705 10.3295C1.7333 10.4992 1.75063 10.6751 1.81684 10.835C1.88305 10.9949 1.99517 11.1315 2.13903 11.2277C2.28289 11.3238 2.45203 11.3751 2.62506 11.3752ZM8.75006 17.5002V13.1252H12.2501V17.5002H8.75006ZM10.5001 3.86243L15.7501 9.11243V13.1252L15.7509 17.5002H14.0001V13.1252C14.0001 12.1601 13.2152 11.3752 12.2501 11.3752H8.75006C7.78493 11.3752 7.00006 12.1601 7.00006 13.1252V17.5002H5.25006V9.11243L10.5001 3.86243Z",
    fill: "#042A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDark);
export default __webpack_public_path__ + "static/media/home_dark.40477cb95a1bcce3704e3e7140d1a65e.svg";
export { ForwardRef as ReactComponent };